/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ corrected: NonNullable<unknown>, merged: NonNullable<unknown>, failed: NonNullable<unknown> }} Auto_Correct_SummaryInputs */

const en_auto_correct_summary = /** @type {(inputs: Auto_Correct_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Corrected ${i?.corrected}, merged ${i?.merged}, failed ${i?.failed} — failed events marked unapproved`)
};

const fr_auto_correct_summary = /** @type {(inputs: Auto_Correct_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.corrected} corrigés, ${i?.merged} fusionnés, ${i?.failed} échoués — les événements en échec ont été marqués comme non approuvés`)
};

const de_auto_correct_summary = /** @type {(inputs: Auto_Correct_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.corrected} korrigiert, ${i?.merged} zusammengeführt, ${i?.failed} fehlgeschlagen — fehlgeschlagene Ereignisse wurden als nicht genehmigt markiert`)
};

const it_auto_correct_summary = /** @type {(inputs: Auto_Correct_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.corrected} corretti, ${i?.merged} uniti, ${i?.failed} falliti — gli eventi falliti sono stati contrassegnati come non approvati`)
};

const ru_auto_correct_summary = /** @type {(inputs: Auto_Correct_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Исправлено: ${i?.corrected}, объединено: ${i?.merged}, не удалось: ${i?.failed} — неисправленные события помечены как неутверждённые`)
};

const es_auto_correct_summary = /** @type {(inputs: Auto_Correct_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.corrected} corregidos, ${i?.merged} fusionados, ${i?.failed} fallidos — los eventos fallidos se marcaron como no aprobados`)
};

const zh_cn2_auto_correct_summary = /** @type {(inputs: Auto_Correct_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已更正 ${i?.corrected} 个，已合并 ${i?.merged} 个，失败 ${i?.failed} 个 — 失败的事件已标记为未批准`)
};

const ja_auto_correct_summary = /** @type {(inputs: Auto_Correct_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.corrected}件修正、${i?.merged}件結合、${i?.failed}件失敗 — 失敗したイベントは未承認としてマークされました`)
};

const hi_auto_correct_summary = /** @type {(inputs: Auto_Correct_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.corrected} सुधारे गए, ${i?.merged} विलय किए गए, ${i?.failed} विफल — विफल घटनाओं को अस्वीकृत चिह्नित किया गया`)
};

const pt_pt2_auto_correct_summary = /** @type {(inputs: Auto_Correct_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.corrected} corrigidos, ${i?.merged} fundidos, ${i?.failed} falhados — os eventos falhados foram marcados como não aprovados`)
};

/**
* | output |
* | --- |
* | "Corrected {corrected}, merged {merged}, failed {failed} — failed events marked unapproved" |
*
* @param {Auto_Correct_SummaryInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_correct_summary = /** @type {((inputs: Auto_Correct_SummaryInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Correct_SummaryInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_auto_correct_summary(inputs)
	if (locale === "de") return de_auto_correct_summary(inputs)
	if (locale === "it") return it_auto_correct_summary(inputs)
	if (locale === "ru") return ru_auto_correct_summary(inputs)
	if (locale === "es") return es_auto_correct_summary(inputs)
	if (locale === "zh-CN") return zh_cn2_auto_correct_summary(inputs)
	if (locale === "ja") return ja_auto_correct_summary(inputs)
	if (locale === "hi") return hi_auto_correct_summary(inputs)
	if (locale === "pt-PT") return pt_pt2_auto_correct_summary(inputs)
	return en_auto_correct_summary(inputs)
});